import axios from "axios";
import { FACEBOOK_CLIENT_ID, FACEBOOK_CLIENT_SECRET, INSTA_CLIENT_ID, GOOGLE_CLIENT_ID, GOOGLE_CLIENT_SECRET, INSTA_CLIENT_SECRET } from "../../../actions/constant";
import { GET_ACCOUNT_DETAILS, HOST_URL, NETWORK_AUTH, LIVE_API } from "../../../actions/api";
import { isAppleSafari } from "../../../utils";
import HttpClient from "../../../actions/http-client";
import { addAccount } from "../../../actions/addFeedActions";
import { toast } from "react-toastify";
import CryptoJS from 'crypto-js';

export const sendAuthenticationCode = (networkId, code, connectionType) => {
    try {
        const isSafari = isAppleSafari();
        const channel = isSafari ? window : new BroadcastChannel('connect');

        if (isSafari) {
            if (networkId == 1) {
                localStorage.setItem('authCodeSafari', JSON.stringify({ networkId: networkId, data: code, type: connectionType }));
            } else {
                window.opener.postMessage(JSON.stringify({ networkId: networkId, data: code, type: connectionType }), '*');
            }
        } else {
            channel.postMessage(JSON.stringify({ networkId: networkId, data: code, type: connectionType }));
        }

        setTimeout(() => {
            window.close();
        }, 2000)
    } catch (error) {
        window.close();
    }
}


export const addFacebookAccount = (code, networkId, callback) => {

    axios.get(`https://graph.facebook.com/v15.0/oauth/access_token?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${`https://${LIVE_API ? "app" : "staging-app"}.socialwalls.com`}/feeds/authCallback&client_secret=${FACEBOOK_CLIENT_SECRET}&code=${code}`).then(res => {
        const { data } = res;

        if (data) {
            var accObj = { token: data.access_token || "", networkId: networkId, reconnectAccount: 0, feedId: 0, type: 4 }
            callback(accObj);
        }
    });
}


export const getFacebookDetails = (data) => {
    const appSecretProof = generateAppSecretProof(data.access_token);

    var getUserUrl = 'https://graph.facebook.com/me?fields=id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender&limit=100&access_token=' + data.access_token + '&appsecret_proof=' + appSecretProof;

    return axios.get(getUserUrl, {
        headers: { authorization: `Bearer ${data.access_token}`, }
    });
}

export const getAccountDetails = (code, networkId, product, callback) => {
    new HttpClient().post(GET_ACCOUNT_DETAILS, { token: code, code, networkId, type: product }).then(response => {
        const { responseCode, responseData } = response.data;
        if (responseCode == 200) {
            callback(responseData);
        }
    }).catch(ex => {
        callback(null);
    })
}

export const addInstaPersonalAccount = (code, callback) => {
    new HttpClient().post(NETWORK_AUTH, { code, networkId: 2 }).then(res => {
        if (res?.data) callback({ token: res.data.responseData.access_token || "", networkId: 2, reconnectAccount: 0, feedId: 0, type: 4 });
    });
}

export const addGoogleReviewAccount = (code, callback) => {

    var payload = { code: code, client_id: GOOGLE_CLIENT_ID, client_secret: GOOGLE_CLIENT_SECRET, redirect_uri: `${HOST_URL}/feeds/authCallback`, access_type: "offline", grant_type: "authorization_code", }

    axios.post(`https://oauth2.googleapis.com/token`, payload).then(res => {
        var accObj = {
            networkId: 4,
            token: res.data.access_token,
            expires_in: res.data.expires_in,
            refresh_token: res.data.refresh_token,
            scope: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/business.manage openid https://www.googleapis.com/auth/business.manage",
            token_type: res.data.token_type,
            id_token: res.data.id_token,
            created: 1675254640,
            reconnectAccount: 0,
            feedId: 0,
            type: 4
        }

        callback(accObj);
    }).catch(ex => {
        // code already use ho chuka ho to Google 400 (invalid_grant) deta hai - silently
        // fail hone par callback me `({token})` destructure crash kar deta tha
        console.log("google token exchange failed --->", ex?.response?.data || ex?.message);
        callback({});
    })

}

export const googleUserDetails = (token) => {
    return axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export const addUserAccount = (networkId, token, callback, ownerId, filter = 0, reconnectAccount = 0, feedId = 0) => {
    var accObj = {
        networkId: networkId,
        token: token,
        reconnectAccount: reconnectAccount,
        feedId: feedId,
        type: 4,
        ownerId: ownerId,
    }
    if ([8, 28, 27, 1, 32].includes(parseInt(networkId))) accObj['code'] = token;
    else if (networkId == 21) accObj['type'] = 6;

    if (networkId == 2) {
        addInstaPersonalAccount(token, (data) => addAccountApiCall({ ...data, reconnectAccount: reconnectAccount, feedId: feedId, ownerId: ownerId }, callback));
    } else if (networkId == 4) {
        addGoogleReviewAccount(token, (data) => addAccountApiCall({ ...data, reconnectAccount: reconnectAccount, feedId: feedId, ownerId: ownerId }, callback));
    } else if (networkId == 3 || networkId == 18) {
        addFacebookAccount(token, networkId, (data) => addAccountApiCall({ ...data, reconnectAccount: reconnectAccount, feedId: feedId, ownerId: ownerId }, callback, filter))
    } else {
        addAccountApiCall(accObj, callback);
    }
}

const addAccountApiCall = (obj, callback, filter = 0) => {
    addAccount(obj).then(res => {
        const { responseCode, createdAccount, responseData, responseMessage } = res.data;
        if (responseCode == 200) {
            //55,62, facebook //rest insta //thread filter = 32
            if ([24, 55, 62, 86, 88].includes(filter)) callback(responseData);
            else callback(createdAccount, responseData?.username ?? "");
            toast.success(responseMessage, { autoClose: 2000 });
        } else {
            toast.error(responseMessage, { autoClose: 2000 });
        }
    }).catch(ex => {

    })
}

const generateAppSecretProof = (accessToken) => {
    // Convert appSecret and accessToken to CryptoJS WordArrays
    var appSecretWordArray = CryptoJS.enc.Utf8.parse(FACEBOOK_CLIENT_SECRET);
    var accessTokenWordArray = CryptoJS.enc.Utf8.parse(accessToken);

    var appSecretProof = CryptoJS.HmacSHA256(accessTokenWordArray, appSecretWordArray);

    return appSecretProof.toString(CryptoJS.enc.Hex);
}